// import EmployeeList from "../../views/apps/employees/employees/EmployeeList.vue";
import EmployeeList from "../../views/apps/employees/profiles/ProfilesList.vue";
import PositionList from "../../views/apps/employees/positions/PositionList.vue";
import DepartmentList from "../../views/apps/employees/departments/DepartmentList.vue";
import DirectionList from "../../views/apps/employees/directions/DirectionList.vue";
// import Permisos from "../../views/apps/employees/RRHH/Permisos.vue";
import ModulosRRHH from "../../views/apps/employees/RRHH/Modules/Modules.vue";
// import KPIAusentismo from "../../views/apps/employees/RRHH/KPIAusentismo.vue";
// import Organigrama from "../../views/apps/employees/RRHH/Organigramas.vue";
// import ProfilesList from "../../views/apps/employees/profiles/ProfilesList.vue";
// import MasterEmployeesList from "../../views/apps/employees/masterEmployees/MasterEmployeesList.vue";
import CustomersList from "../../components/customers/CustomersList";
import ReportSales from "../../views/modules/sales/reports/ReportSales.vue";
import InventoryIntemp from "../../views/modules/projects/InventoryIntemp";
import MaintenanceCalendarP from "../../views/apps/calendar/CalendarMaintenanceNotBreadcrumb";
import Providers from "../../views/modules/projects/Providerlist";
import Nomina from "@/views/apps/employees/Nomina/Nomina.vue";
import IncomeTypes from "@/views/apps/employees/Nomina/Maintenance/IncomeTypes.vue";
import DiscountsTypes from "@/views/apps/employees/Nomina/Maintenance/DiscountsTypes.vue";
import ISRtops from "@/views/apps/employees/Nomina/Maintenance/ISRtops.vue";
import layouts from "../../layout";

import roles from "@/roles";
export default {
  path: "/employees",
  name: "employees",
  component: () =>
    import(
      /* webpackChunkName: "employees" */ "../../views/apps/employees/Employees.vue"
    ),
  meta: {
    auth: true,
    title: "Empleados",
    tags: ["employees"]
  },
  redirect: {
    name: "employees-employee"
  },
  children: [
    // Empleados
    {
      path: "Provider",
      name: "rrhh-provider",
      component: Providers,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Proveedores",
        tags: ["rrhh", "provider"],
        index: true,
        roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
      }
    },
    {
      path: "",
      name: "employees-employee",
      component: EmployeeList,
      meta: {
        auth: true,
        searchable: true,
        title: "Employees",
        layout: layouts.navLeft,
        tags: ["employees", "employee"],
        index: true,
        roles: [
          roles.GerenteRRHH,
          roles.CEO,
          roles.SuperUsuario,
          roles.ContactoEmergente
        ]
      }
    },
    {
      path: "Nomina",
      name: "employees-nomina",
      component: Nomina,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Nomina",
        index: true,
        roles: [
          roles.GerenteRRHH,
          roles.CEO,
          roles.SuperUsuario,
          roles.Nomina_CEO,
          roles.Nomina_Finanzas,
          roles.Nomina_RH
        ]
      }
    },
    // {
    //   path: "Permisos",
    //   name: "permissions",
    //   component: Permisos,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     title: "Permisos",
    //     layout: layouts.navLeft,
    //     tags: ["employees", "Permisos"],
    //     index: true
    //   }
    // },
    {
      path: "ModulosRRHH",
      name: "Modules",
      component: ModulosRRHH,
      meta: {
        auth: true,
        searchable: true,
        title: "Modules",
        layout: layouts.navLeft,
        tags: ["employees", "ModulosRRHH"],
        index: true
      }
    },
    // {
    //   path: "KPIAusentismo",
    //   name: "KPIAusentismo",
    //   component: KPIAusentismo,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     title: "KPI-Ausentismo",
    //     layout: layouts.navLeft,
    //     tags: ["employees", "KPIAusentismo"],
    //     index: true
    //   }
    // },
    // {
    //   path: "Organigramas",
    //   name: "Organizationchart",
    //   component: Organigrama,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     title: "KPI-Organigramas",
    //     layout: layouts.navLeft,
    //     tags: ["employees", "Organigramas"],
    //     index: true
    //   }
    // },
    {
      path: "/organization_chart",
      name: "organization_chart",
      component: {
        name: "organizationChart",
        render: (h) => h("router-view")
      },
      meta: {
        auth: true
      },
      children: [
        {
          path: "directions",
          name: "employees-directions",
          component: DirectionList,
          meta: {
            auth: true,
            searchable: true,
            title: "Employees Directions",
            layout: layouts.navLeft,
            tags: ["employees", "directions"],
            index: true,
            roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
          }
        },
        // Departamentos
        {
          path: "departments",
          name: "employees-departments",
          component: DepartmentList,
          meta: {
            auth: true,
            searchable: true,
            title: "Employees Departments",
            layout: layouts.navLeft,
            tags: ["employees", "departments"],
            index: true,
            roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
          }
        },
        // Posiciones
        {
          path: "positions",
          name: "employees-positions",
          component: PositionList,
          meta: {
            auth: true,
            searchable: true,
            title: "Employees Positions",
            layout: layouts.navLeft,
            tags: ["employees", "positions"],
            index: true,
            roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
          }
        }
      ]
    },
    {
      path: "customersRRHH",
      name: "sales-customersRRHH",
      component: CustomersList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Sales Customers",
        tags: ["sales", "customer"],
        index: true,
        roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
      }
    },
    {
      path: "reportSales",
      name: "report-sales-per-vendorRRHH",
      component: ReportSales,
      meta: {
        auth: true,
        searchable: true,
        title: "REPORTE DE VENTAS",
        layout: layouts.navLeft,
        tags: ["employees", "report"],
        index: true,
        roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
      }
    },
    {
      path: "inventory",
      name: "RHH-inventory",
      component: InventoryIntemp,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Inventory",
        tags: ["employees", "inventory"],
        index: true,
        roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
      }
    },
    {
      path: "MaintenanCalendar",
      name: "employees-calendarM",
      component: MaintenanceCalendarP,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Agenda de Mantenimiento",
        tags: ["employees", "genda de Mantenimiento"],
        index: true,
        roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
      }
    },

    {
      path: "formcustomer",
      name: "employees-formcustomer",
      component: () =>
        import(
          "@/components/customer_service/customer_survey/SurveyCustomer.vue"
        ),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Formulario para encuentas",
        index: true,
        roles: [
          roles.GerenteRRHH,
          roles.CEO,
          roles.SuperUsuario,
          roles.EncuestaEmpleados
        ]
      }
    },
    {
      path: "reportsurvey",
      name: "employees-reportsurvey",
      component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Respuesta de Empleados",
        index: true,
        // Pass props to the component
        props: {
          // Define your props here
          prop1: "value1",
          prop2: "value2"
          // ...,
        },
        roles: [
          roles.GerenteRRHH,
          roles.CEO,
          roles.SuperUsuario,
          roles.EncuestaEmpleados
        ]
      }
    },
    {
      path: "/payroll_maintenance",
      name: "payroll_maintenance",
      component: () =>
        import(
          /* webpackChunkName: "Employees" */ "@/views/apps/employees/Nomina/Maintenance/Index.vue"
        ),
      meta: {
        auth: true
      },
      children: [
        {
          path: "Incomes",
          name: "Income_Types",
          component: IncomeTypes,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "IncomeTypes",
            index: true,
            roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
          }
        },
        {
          path: "Discount",
          name: "Discount_Types",
          component: DiscountsTypes,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "IncomeTypes",
            index: true,
            roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
          }
        },
        {
          path: "isrTops",
          name: "employees-isrTops",
          component: ISRtops,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Topes ISR",
            index: true,
            roles: [roles.GerenteRRHH, roles.CEO, roles.SuperUsuario]
          }
        }
      ]
    }
  ]
};
